const { API, ENDPOINTS } = require("../utils/secure/secureConfig");

// --- Key/User operations ---
async function initializeUserKeys() {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.initKeys}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify({}),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error initializing user keys:", error);
    throw error;
  }
}

async function getDecryptionKey(chatId) {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.getDecryptionKey(chatId)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      cache: "no-store",
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting decryption key:", error);
    throw error;
  }
}

async function getUserMasterKey() {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.getUserMasterKey}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      cache: "no-store",
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting user master key:", error);
    throw error;
  }
}

// --- Chat operations ---
async function createChat(otherUserId) {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.createChat}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify({ otherUserId }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating chat:", error);
    throw error;
  }
}

async function createGroup(userIds, groupName, groupDescription = "") {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.createGroup}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify({ userIds, groupName, groupDescription }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating group:", error);
    throw error;
  }
}

async function getChats() {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.getChats}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting chats:", error);
    throw error;
  }
}

async function getChatsWithUnreadCount() {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.getChatsWithUnreadCount}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting chats with unread count:", error);
    throw error;
  }
}

async function getChat(chatId) {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.getChat(chatId)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting chat:", error);
    throw error;
  }
}

// --- Message operations ---
async function getMessages(chatId, { page, limit } = {}) {
  try {
    let token = localStorage.getItem("loginDetails");
    let url = `${API.secureMessageBase}${ENDPOINTS.getMessages(chatId)}`;
    const params = new URLSearchParams();
    if (page) params.set("page", String(page));
    if (limit) params.set("limit", String(limit));
    if ([...params.keys()].length) url += `?${params.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting messages:", error);
    throw error;
  }
}

async function sendMessage({ chatId, ciphertext, iv, authTag }) {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.sendMessage}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify({ chatId, ciphertext, iv, authTag }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error sending message:", error);
    throw error;
  }
}

async function editMessage(messageId, { ciphertext, iv, authTag }) {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.editMessage(messageId)}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify({ ciphertext, iv, authTag }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error editing message:", error);
    throw error;
  }
}

async function deleteMessage(messageId) {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.deleteMessage(messageId)}`;
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting message:", error);
    throw error;
  }
}

async function markMessagesRead(chatId, messageIds = []) {
  try {
    let token = localStorage.getItem("loginDetails");
    const url = `${API.secureMessageBase}${ENDPOINTS.markMessagesRead}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify({ chatId, messageIds }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error marking messages read:", error);
    throw error;
  }
}

module.exports = {
  initializeUserKeys,
  getDecryptionKey,
  getUserMasterKey,
  createChat,
  createGroup,
  getChats,
  getChatsWithUnreadCount,
  getChat,
  getMessages,
  sendMessage,
  editMessage,
  deleteMessage,
  markMessagesRead,
};
